<span *ngIf="classification === EHarshDrivingEventClassification.Collision"
  class="harsh-driving-event-balloon-badge harsh-driving-event-balloon-badge--collision"
  i18n="@@S_VIDEO_COLLISION">Collision</span>
<span *ngIf="classification === EHarshDrivingEventClassification.Dangerous"
  class="harsh-driving-event-balloon-badge harsh-driving-event-balloon-badge--dangerous"
  i18n="@@S_LIVEMAP_HDE_DANGEROUS">Dangerous</span>
<span *ngIf="classification === EHarshDrivingEventClassification.HarshDriving"
  class="harsh-driving-event-balloon-badge harsh-driving-event-balloon-badge--harsh-driving"
  i18n="@@S_VIDEO_HARSH_DRIVING">Harsh Driving</span>
<span *ngIf="classification === EHarshDrivingEventClassification.LowRisk"
  class="harsh-driving-event-balloon-badge harsh-driving-event-balloon-badge--low-risk"
  i18n="@@S_VIDEO_LOW_RISK">Low Risk</span>
<span *ngIf="classification === EHarshDrivingEventClassification.Undetermined"
  class="harsh-driving-event-balloon-badge harsh-driving-event-balloon-badge--undetermined"
  i18n="@@S_VIDEO_UNDETERMINED">Undetermined</span>
